import { Grid, Typography } from "@material-ui/core";
import React from "react";
import PayhereForm from "../payhere-form";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPaymentMethod } from "../../../../../../../store/actions/pay-for-ad";
import {
  PAYMENT_METHOD_IDS,
  PAYMENT_TYPES,
} from "../../../../../../../config/constant";

const PaymentMethodCard = ({ data = {}, session }) => {
  const dispatch = useDispatch();
  const recurringPayment =
    sessionStorage.getItem(PAYMENT_TYPES.IS_RECURRING) === "true";

  const { selectedPaymentMethod } = useSelector((state) => state.payForAd);

  const paymentMethodName =
    data.id === PAYMENT_METHOD_IDS.LOCAL_CC
      ? "Sri Lankan Payment Gateway"
      : data.id === PAYMENT_METHOD_IDS.FOREIGN_CC
      ? "International Payment Gateway"
      : data.name ?? "";

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      className={`payment-method-card ${
        selectedPaymentMethod.id === data.id && "payment-method-card-selected"
      }`}
      onClick={() => {
        dispatch(setSelectedPaymentMethod(data));
      }}
    >
      <img src={data.icon} alt="payment-method" style={{ height: 33 }} />
      <Typography variant="body2">{paymentMethodName}</Typography>
      <PayhereForm isRecurring={recurringPayment} session={session} />
    </Grid>
  );
};

export default PaymentMethodCard;
